import { CreateOrUpdateActionException } from 'utils/error';
import { isRecord } from 'utils/typeChecks';

export interface HandleSaveErrorOptions {
  onActionError: () => void;
  onUnknownError: () => void;
  onLockConflict?: () => void;
}

const isLockConflictStatus = (error: Record<string, unknown>): boolean => error.status === 409 || error.status === '409';

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }

  if (isRecord(error)) {
    if (typeof error.error === 'string' && error.error) {
      return error.error;
    }

    if (isRecord(error.data)) {
      if (typeof error.data.message === 'string' && error.data.message) {
        return error.data.message;
      }
      if (typeof error.data.title === 'string' && error.data.title) {
        return error.data.title;
      }
    }

    if (typeof error.data === 'string' && error.data) {
      return error.data;
    }

    if (typeof error.message === 'string' && error.message) {
      return error.message;
    }

    if (typeof error.status === 'number' || typeof error.status === 'string') {
      return `Request failed with status ${error.status}`;
    }
  }

  return String(error);
};

export const handleSaveError = (error: unknown, options: HandleSaveErrorOptions): void => {
  if (error instanceof CreateOrUpdateActionException) {
    // eslint-disable-next-line no-console
    console.error('Action failed:', error.message);
    options.onActionError();
    return;
  }

  if (isRecord(error) && isLockConflictStatus(error) && options.onLockConflict) {
    options.onLockConflict();
    return;
  }

  const errorMessage = getErrorMessage(error);
  // eslint-disable-next-line no-console
  console.error('Failed to update record:', errorMessage);
  options.onUnknownError();
};
